<template>
  <div class="columns is-centered">
    <div class="column is-8">
      <div class="main-content section has-text-centered">
        <h2 class="title is-size-4">
          Maintenance in Progress
        </h2>
        <p>
          The Financial Disclosure application is currently undergoing maintenance. It will be available again shortly.
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {};
  },
  created () {},
  methods: {},
};
</script>
